import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { motion } from "framer-motion";

const ProductCard = ({ product, index = 0 }) => {
  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(price);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
    >
      <Link 
        to={`/products/${product.id}`} 
        className="block product-card group"
        data-testid={`product-card-${product.id}`}
      >
        <Card className="cosmic-card rounded-2xl overflow-hidden">
          {/* Image */}
          <div className="aspect-square overflow-hidden relative">
            <img
              src={product.images?.[0] || "https://images.unsplash.com/photo-1545128309-686a71a99f76?w=500"}
              alt={product.name}
              className="w-full h-full object-cover product-card-image"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-mystic-void/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            {product.featured && (
              <Badge 
                className="absolute top-3 left-3 bg-mystic-gold text-mystic-void border-0 font-medium"
                data-testid="featured-badge"
              >
                ✨ Featured
              </Badge>
            )}
            {product.stock <= 5 && product.stock > 0 && (
              <Badge 
                variant="outline" 
                className="absolute top-3 right-3 bg-black/50 text-mystic-orchid border-mystic-orchid/50"
              >
                Low Stock
              </Badge>
            )}
            {product.stock === 0 && (
              <Badge 
                className="absolute top-3 right-3 bg-red-500/80 text-white border-0"
              >
                Out of Stock
              </Badge>
            )}
          </div>

          {/* Content */}
          <CardContent className="p-5 bg-gradient-to-b from-transparent to-mystic-void/50">
            <div className="space-y-2">
              <p className="text-xs uppercase tracking-widest text-mystic-amethyst">
                {product.category === 'healing' ? '✧ Healing Crystal' : '◆ Raw Stone'}
              </p>
              <h3 className="font-serif text-lg font-medium text-mystic-silver group-hover:text-mystic-gold transition-colors line-clamp-1 italic">
                {product.name}
              </h3>
              <p className="text-sm text-mystic-mist/70 line-clamp-2">
                {product.description}
              </p>
              <p className="font-sans font-semibold text-mystic-cyan price-tag pt-2 text-lg">
                {formatPrice(product.price)}
              </p>
            </div>
          </CardContent>
        </Card>
      </Link>
    </motion.div>
  );
};

export default ProductCard;
